import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import SpinnerWithLoadMask from "components/SpinnerWithLoadMask";
import FoldersContent from "layout/folders/FoldersContent";
import ErrorFallbackModal from "components/Modal/ErrorFallbackModal";

const Folders = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallbackModal}>
      <SpinnerWithLoadMask opacity={0.7} fullScreen />
      <FoldersContent />
    </ErrorBoundary>
  );
};

export default Folders;
